export default __webpack_public_path__ + "static/media/acelepryn-award.6891cfcc.png";